import { render, staticRenderFns } from "./servisMarkup.vue?vue&type=template&id=25de0995&scoped=true&"
import script from "./servisMarkup.vue?vue&type=script&lang=ts&"
export * from "./servisMarkup.vue?vue&type=script&lang=ts&"
import style0 from "./servisMarkup.vue?vue&type=style&index=0&id=25de0995&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25de0995",
  null
  
)

export default component.exports